<template>
  <div class="ec-line016">
    <el-breadcrumb separator="/">
      <el-breadcrumb-item>
        <a :href="baseUrl">{{ this.shopName }}</a></el-breadcrumb-item
      >
      <el-breadcrumb-item :to="{ path: $routePage.EC_LINE009 }"> {{ $t('ec-line009.heading') }}</el-breadcrumb-item>
      <el-breadcrumb-item> {{ $t('ec-line016.heading') }}</el-breadcrumb-item>
    </el-breadcrumb>
    <the-heading>{{ $t('ec-line016.heading') }}</the-heading>

    <history-product-list>
      <product-item
        v-for="item in products"
        :key="item.id"
        :id="item.id"
        :img="item.img"
        :title="item.title"
        :description="item.description"
        :category="item.category"
        :price="item.price"
        :url="{ name: 'EC_LINE017', params: { id: item.id } }"
      />
    </history-product-list>
    <div class="w-full text-center">
      <el-button class="cancel-btn lg:mb-4 mb-1" @click="toProductDetail">{{ $t('common.action.cancel') }}</el-button>
    </div>
  </div>
</template>

<script>
import TheHeading from '@/components/my-page-partials/TheHeading.vue'
import HistoryProductList from '@/components/ec-line016/HistoryProductList.vue'
import ProductItem from '@/components/ProductItem.vue'
import { ProductService } from '@/services'
import { ENV_KEY } from '@/constants/env'
import BreadcrumbMixin from '@/mixins/breadcrumb'

export default {
  components: { TheHeading, HistoryProductList, ProductItem },
  mixins: [BreadcrumbMixin],
  data() {
    return {
      products: [],
    }
  },
  computed: {
    subscription() {
      return this.$store.getters['subscription/getSubscription']
    },
  },
  created() {
    if (this.subscription) {
      this.fetchData()
    } else {
      this.$router.push({ name: 'EC_LINE014' })
    }
  },
  methods: {
    async fetchData() {
      const { data } = await ProductService.getProducts({
        sale_type: [this.Constants.SALE_TYPE.SUBSCRIPTION, this.Constants.SALE_TYPE.BOTH].join(','),
        product_status: 1, // public
      })

      this.products = data.items.map((i) => {
        const minPrice = this.getMinPrice(i)
        const maxPrice = this.getMaxPrice(i)

        return Object.assign({
          id: i.product_id,
          img: `${this.$store.getters['env/GET_KEY'](ENV_KEY.IMAGE_API)}/${i.product_image}`,
          title: i.product_name,
          description: i.product_caption,
          price:
            minPrice !== maxPrice
              ? `${this.$n(minPrice, 'currency', 'ja-JP')}~${this.$n(maxPrice, 'currency', 'ja-JP')}`
              : this.$n(minPrice, 'currency', 'ja-JP'),
        })
      })
    },
    getMinPrice(product) {
      return Number(product.product_regular_price_min_after_tax)
    },
    getMaxPrice(product) {
      return Number(product.product_regular_price_max_after_tax)
    },
    toProductDetail() {
      this.$router.push({ name: 'EC_LINE015', params: { id: this.subscription.id } })
    },
  },
  metaInfo() {
    return {
      title: this.$t('ec-line016.title'),
      meta: [
        {
          vmid: 'description',
          name: 'description',
          content: this.$t('ec-line016.description', { shop_name: this.shopName }),
        },
        {
          vmid: 'keywords',
          name: 'keywords',
          content: this.$t('ec-line016.keyword', { shop_name: this.shopName }),
        },
      ],
    }
  },
}
</script>

<style></style>
